import api from "@/api/api";
import { iniciarRequisicao, logout } from "@/helpers";
import { STATUS_HTTP } from "@/api/statusHTTP";

//Modulos
export const buscarModulosConfiguracaoMenuParametrizacao = async (parametros) => {
  const url = `/parametrizacao/configuracao-menu/modulo`;
  const {data, status} = await api.get(url, {parametros, headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.modulos;
}

export const salvarModulosConfiguracaoMenuParametrizacao = async (parametros) => {
  const url = `/parametrizacao/configuracao-menu/modulo`;
  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return ;
}

export const editarModulosConfiguracaoMenuParametrizacao = async (parametros) => {
  const url = `/parametrizacao/configuracao-menu/modulo/${parametros.id}`;
  const { data, status } = await api.put(url, parametros, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return ;
}

export const deletarModulosConfiguracaoMenuParametrizacao = async (parametros) => {
  const url = `/parametrizacao/configuracao-menu/modulo/${parametros.id}`;
  const { data, status } = await api.delete(url, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return ;
}

//Menu
export const buscarMenusConfiguracaoMenuParametrizacao = async (parametros) => {
  const url = `/parametrizacao/configuracao-menu/menu`;
  const {data, status} = await api.get(url, {parametros, headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.menus;
}

export const salvarMenusConfiguracaoMenuParametrizacao = async (parametros) => {
  const url = `/parametrizacao/configuracao-menu/menu`;
  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return ;
}

export const editarMenusConfiguracaoMenuParametrizacao = async (parametros) => {
  const url = `/parametrizacao/configuracao-menu/menu/${parametros.id}`;
  const { data, status } = await api.put(url, parametros, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return ;
}

export const deletarMenusConfiguracaoMenuParametrizacao = async (parametros) => {
  const url = `/parametrizacao/configuracao-menu/menu/${parametros.id}`;
  const { data, status } = await api.delete(url, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return ;
}

//Sub Menu
export const buscarSubMenusConfiguracaoMenuParametrizacao = async (parametros) => {
  const url = `/parametrizacao/configuracao-menu/sub-menu`;
  const {data, status} = await api.get(url, {parametros, headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.sub_menus;
}

export const salvarSubMenusConfiguracaoMenuParametrizacao = async (parametros) => {
  const url = `/parametrizacao/configuracao-menu/sub-menu`;
  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return ;
}

export const editarSubMenusConfiguracaoMenuParametrizacao = async (parametros) => {
  const url = `/parametrizacao/configuracao-menu/sub-menu/${parametros.id}`;
  const { data, status } = await api.put(url, parametros, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return ;
}

export const deletarSubMenusConfiguracaoMenuParametrizacao = async (parametros) => {
  const url = `/parametrizacao/configuracao-menu/sub-menu/${parametros.id}`;
  const { data, status } = await api.delete(url, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return ;
}
